// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// Solo para confirmar que se ejecuta:
console.log('✅ index.js se está ejecutando');
// alert('index.js se está ejecutando');  // lo puedes dejar o comentar

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
